import React, { Component } from "react";

const IS_PRODUCTION = process.env.NODE_ENV === "production";
const PUBLIC_ROUTE_PREFIXES = ["/login", "/forgot-password", "/reset-password", "/set-password", "/logout"];

const styles = {
  shell: {
    minHeight: "100vh",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    background:
      "radial-gradient(900px 520px at 14% 14%, rgba(136, 156, 231, 0.12), transparent 58%), radial-gradient(780px 520px at 84% 16%, rgba(194, 77, 231, 0.1), transparent 60%), linear-gradient(180deg, rgba(2, 4, 12, 0.98), rgba(0, 0, 0, 1))",
    color: "#fff",
    boxSizing: "border-box",
  },
  card: {
    width: "min(760px, 100%)",
    borderRadius: "28px",
    border: "1px solid rgba(136, 156, 231, 0.28)",
    background:
      "radial-gradient(circle at top left, rgba(136, 156, 231, 0.18), transparent 42%), radial-gradient(circle at top right, rgba(194, 77, 231, 0.14), transparent 38%), linear-gradient(180deg, rgba(10, 12, 22, 0.94), rgba(0, 0, 0, 0.9))",
    boxShadow:
      "0 30px 80px rgba(0, 0, 0, 0.5), 0 0 28px rgba(136, 156, 231, 0.16), inset 0 1px 0 rgba(255, 255, 255, 0.05)",
    padding: "28px 28px 24px",
    textAlign: "center",
  },
  hero: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    marginBottom: "18px",
  },
  pill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px 22px",
    borderRadius: "999px",
    border: "1px solid rgba(136, 156, 231, 0.9)",
    background:
      "radial-gradient(circle at top left, rgba(136, 156, 231, 0.25), rgba(0, 0, 0, 0.9))",
    boxShadow:
      "0 0 18px rgba(136, 156, 231, 0.9), 0 0 34px rgba(136, 156, 231, 0.5)",
    textTransform: "uppercase",
  },
  label: {
    fontFamily: '"FuturisticArmor", sans-serif',
    fontSize: "1.75rem",
    letterSpacing: "0.16em",
    opacity: 0.95,
  },
  tag: {
    padding: "3px 10px",
    borderRadius: "999px",
    border: "1px solid rgba(194, 77, 231, 0.9)",
    background: "radial-gradient(circle at top left, #c24de7, #1a1a3b)",
    fontFamily: '"FuturisticArmor", sans-serif',
    fontSize: "0.8rem",
    letterSpacing: "0.16em",
    textTransform: "uppercase",
  },
  shimmer: {
    width: "300px",
    maxWidth: "100%",
    height: "3px",
    borderRadius: "999px",
    background:
      "linear-gradient(90deg, transparent, rgba(136, 156, 231, 0.95), transparent)",
    filter: "drop-shadow(0 0 12px rgba(136, 156, 231, 0.9))",
  },
  title: {
    margin: 0,
    fontFamily: '"FuturisticArmor", sans-serif',
    fontSize: "1.45rem",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#fff",
  },
  copy: {
    margin: "12px auto 0",
    maxWidth: "560px",
    fontFamily: '"AquireLight", sans-serif',
    fontSize: "0.95rem",
    lineHeight: 1.7,
    color: "rgba(255, 255, 255, 0.8)",
  },
  routeBadge: {
    margin: "16px auto 0",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px 14px",
    borderRadius: "999px",
    border: "1px solid rgba(255, 255, 255, 0.08)",
    background: "rgba(255, 255, 255, 0.05)",
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
    fontSize: "0.8rem",
    color: "rgba(255, 255, 255, 0.76)",
  },
  buttonRow: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "12px",
    marginTop: "22px",
  },
  primaryButton: {
    minWidth: "190px",
    padding: "12px 18px",
    borderRadius: "999px",
    border: "1px solid rgba(136, 156, 231, 0.3)",
    background:
      "linear-gradient(180deg, rgba(12, 16, 30, 0.92), rgba(0, 0, 0, 0.94))",
    color: "#fff",
    fontFamily: '"FuturisticArmor", sans-serif',
    fontSize: "0.9rem",
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    cursor: "pointer",
    boxShadow: "0 16px 44px rgba(0, 0, 0, 0.45), 0 0 20px rgba(136, 156, 231, 0.12)",
  },
  secondaryButton: {
    minWidth: "190px",
    padding: "12px 18px",
    borderRadius: "999px",
    border: "1px solid rgba(194, 77, 231, 0.3)",
    background:
      "linear-gradient(180deg, rgba(18, 10, 28, 0.92), rgba(0, 0, 0, 0.94))",
    color: "#fff",
    fontFamily: '"FuturisticArmor", sans-serif',
    fontSize: "0.9rem",
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    cursor: "pointer",
    boxShadow: "0 16px 44px rgba(0, 0, 0, 0.45), 0 0 20px rgba(194, 77, 231, 0.12)",
  },
  debug: {
    marginTop: "22px",
    padding: "16px 18px",
    borderRadius: "18px",
    border: "1px solid rgba(255, 255, 255, 0.08)",
    background: "rgba(255, 255, 255, 0.04)",
    textAlign: "left",
    overflowX: "auto",
  },
  debugTitle: {
    margin: 0,
    fontFamily: '"FuturisticArmor", sans-serif',
    fontSize: "0.78rem",
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "rgba(255, 255, 255, 0.68)",
  },
  pre: {
    margin: "10px 0 0",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
    fontSize: "0.82rem",
    lineHeight: 1.6,
    color: "rgba(255, 255, 255, 0.88)",
  },
};

function readRoutePath(explicitRoutePath) {
  if (explicitRoutePath) return String(explicitRoutePath);
  if (typeof window !== "undefined" && window.location?.pathname) {
    return String(window.location.pathname);
  }
  return "";
}

function isPublicRoute(routePath) {
  const path = String(routePath || "").trim();
  if (!path) return false;
  if (path.startsWith("/authorize/return")) return true;
  return PUBLIC_ROUTE_PREFIXES.includes(path);
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      componentStack: "",
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error, info) {
    this.setState({
      componentStack: info?.componentStack || "",
    });

    /*
     * ALWAYS report, production included.
     *
     * This used to log only outside production, so a route that died in
     * production died silently: the operator saw "Page Unavailable" and the
     * console was clean. /optimus was down for every user on an unconditional
     * ReferenceError and left no diagnostic trail at all.
     *
     * Suppressing the report is not the same as hiding the details from the
     * user. The Development Details PANEL stays dev-only below — what ships to
     * production is a single structured console record naming the route, the
     * message and the component stack, which is the minimum needed to triage a
     * dead route from a bug report or a session replay.
     */
    const routePath = readRoutePath(this.props.routePath);
    try {
      console.error("[cphere] route boundary caught an error", {
        route: routePath || "(unknown)",
        message: error?.message || String(error || "Unknown error"),
        name: error?.name || null,
        stack: error?.stack || null,
        componentStack: info?.componentStack || "",
      });
    } catch (_reportingError) {
      /* Reporting must never itself take the boundary down. */
    }
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({
        hasError: false,
        error: null,
        componentStack: "",
      });
    }
  }

  handleReload = () => {
    if (typeof window !== "undefined") {
      window.location.reload();
    }
  };

  handleGoToDashboard = () => {
    const target = this.props.dashboardPath || "/dashboard";
    if (typeof window !== "undefined") {
      window.location.assign(target);
    }
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    const errorMessage =
      this.state.error?.message || String(this.state.error || "Unknown error");
    const routePath = readRoutePath(this.props.routePath);
    const showDashboardAction = Boolean(this.props.dashboardPath) && !isPublicRoute(routePath);

    return (
      <div style={styles.shell}>
        <div style={styles.card}>
          <div style={styles.hero}>
            <div style={styles.pill}>
              <span style={styles.label}>Page</span>
              <span style={styles.tag}>Unavailable</span>
            </div>
            <div style={styles.shimmer} />
          </div>

          <h1 style={styles.title}>Page Unavailable</h1>
          <p style={styles.copy}>
            Something went wrong while rendering this route. You can reload the page or return to the dashboard while we keep the rest of the app available.
          </p>

          {routePath ? <div style={styles.routeBadge}>Route: {routePath}</div> : null}

          <div style={styles.buttonRow}>
            {showDashboardAction ? (
              <button type="button" style={styles.primaryButton} onClick={this.handleGoToDashboard}>
                Back To Dashboard
              </button>
            ) : null}
            <button type="button" style={styles.secondaryButton} onClick={this.handleReload}>
              Reload Page
            </button>
          </div>

          {!IS_PRODUCTION ? (
            <div style={styles.debug}>
              <p style={styles.debugTitle}>Development Details</p>
              <pre style={styles.pre}>{errorMessage}</pre>
              {this.state.componentStack ? (
                <pre style={styles.pre}>{this.state.componentStack}</pre>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
